<div class="flex flex-col h-full">
  <div class="title-bar">
    <h3 mat-dialog-title class="flex-important items-center">Sync History for {{ jobName }}</h3>
    <button mat-icon-button aria-label="Cancel changes" matTooltip="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div [hidden]="view === 'single'" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
      <app-loading-overlay *ngIf="syncHistory.getBusyStatus() | async as status" mode="indeterminate"
        ><p>{{ status }}</p></app-loading-overlay
      >
      <ag-grid-angular
        class="ag-theme-balham"
        [context]="context"
        [components]="frameworkComponents"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        (gridReady)="onGridReady($event)"
        [serverSideInfiniteScroll]="true"
      ></ag-grid-angular>
    </div>

    <div [hidden]="view === 'list'" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
      <section *ngIf="activeExecution" class="execution-log" data-test="sync-history-dialog__execution-log">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="log-header">
          <span
            >Ran: {{ activeExecution.start | date : 'M/dd/yyyy HH:mm:ss a' }} -
            {{ activeExecution.end | date : 'HH:mm:ss a' }}</span
          >
          <div></div>

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px">
            <mat-checkbox
              [(ngModel)]="showErrorsOnly"
              data-test="sync-history-dialog__only-errors-checkbox"
            ></mat-checkbox>
            <span>Only show errors</span>
          </div>

          <div *ngIf="!loading" fxLayout="row" fxLayoutGap="12px">
            <button mat-button mat-raised-button color="primary" aria-label="Download log" (click)="refreshLog()">
              Refresh
            </button>
            <button mat-button mat-raised-button color="primary" aria-label="Download log" (click)="downloadLog()">
              Download log
            </button>
          </div>

          <div *ngIf="loading" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
            <span>Retrieving execution log...</span>
          </div>
        </div>

        <div class="log-entries-list" fxLayoutGap="8px" *ngIf="activeExecution.jobId === 'GUARDIAN_SYNC'">
          <div *ngIf="noChangesDetected" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span>No logs detected for this execution [{{ executionId }}].</span>
          </div>

          <div *ngIf="summaryMessage" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span>{{ summaryMessage }}</span>
          </div>

          <mat-accordion>
            <app-single-guardian-log-entry
              *ngFor="let guardian of logContent"
              [data]="guardian"
              [debug]="debug"
              [showErrorsOnly]="showErrorsOnly"
              class="log-content"
            ></app-single-guardian-log-entry>
          </mat-accordion>
        </div>

        <div
          class="log-entries-list"
          fxLayout="column"
          fxLayoutGap="8px"
          *ngIf="activeExecution.jobId !== 'GUARDIAN_SYNC'"
        >
          <div *ngIf="noChangesDetected" fxLayoutAlign="start center" fxLayoutGap="12px">
            <span>No Google classroom changes actioned.</span>
          </div>

          <div *ngIf="activeExecution.summary.teacherReview" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon class="success">check</mat-icon>
            <span
              >{{ activeExecution.summary.teacherReview }} teacher review class{{
                activeExecution.summary.teacherReview === 1 ? '' : 'es'
              }}
              updated.</span
            >
          </div>

          <div
            *ngIf="activeExecution.errors.teacherReview"
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            class="error"
          >
            <mat-icon class="error">close</mat-icon>
            <span
              >{{ activeExecution.errors.teacherReview }} teacher review class{{
                activeExecution.errors.teacherReview === 1 ? '' : 'es'
              }}
              failed to update.</span
            >
          </div>

          <div *ngIf="activeExecution.summary.classroomExceptions" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon class="success">check</mat-icon>
            <span
              >{{ activeExecution.summary.classroomExceptions }} classroom exception{{
                activeExecution.summary.classroomExceptions === 1 ? '' : 's'
              }}
              added.</span
            >
          </div>

          <div *ngIf="activeExecution.summary.rosterChanges?.add" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon class="success">check</mat-icon>
            <span
              >{{ activeExecution.summary.rosterChanges.add }} roster addition{{
                activeExecution.summary.rosterChanges.add === 1 ? '' : 's'
              }}
              made successfully.</span
            >
          </div>

          <div *ngIf="activeExecution.summary.rosterChanges?.remove" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon class="success">check</mat-icon>
            <span
              >{{ activeExecution.summary.rosterChanges.remove }} roster removal{{
                activeExecution.summary.rosterChanges.remove === 1 ? '' : 's'
              }}
              made successfully.</span
            >
          </div>

          <div *ngIf="activeExecution.errors.rosterChanges" fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-icon class="error">error</mat-icon>
            <span
              >{{ activeExecution.errors.rosterChanges }} roster change{{
                activeExecution.errors.rosterChanges === 1 ? '' : 's'
              }}
              could not be made.</span
            >
          </div>

          <mat-accordion>
            <app-single-log-entry
              *ngFor="let cls of logContent"
              [data]="cls"
              [debug]="debug"
              [showErrorsOnly]="showErrorsOnly"
              class="log-content"
            ></app-single-log-entry>
          </mat-accordion>
        </div>

        <div *ngIf="debug" class="debug">
          <h3>{{ activeExecution | json }}</h3>
          <pre>{{ logContent | json }}</pre>
        </div>
      </section>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button
      *ngIf="view === 'single'"
      mat-button
      mat-raised-button
      color="primary"
      aria-label="Back"
      (click)="backToList()"
    >
      Back
    </button>
    <button
      *ngIf="view === 'list'"
      cdkFocusRegionstart
      mat-button
      mat-raised-button
      mat-dialog-close
      color="primary"
      aria-label="Close"
    >
      Close
    </button>
  </mat-dialog-actions>
</div>
